export type Language = 'pl' | 'en';

export const SUPPORTED_LANGUAGES: { code: Language; label: string; flag: string }[] = [
  { code: 'pl', label: 'Polski', flag: '🇵🇱' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
];

const translations = {
  pl: {
    // Nav
    nav_overview: 'Przegląd',
    nav_leaderboard: 'Ranking',
    nav_hall_of_fame: 'Sala Sławy',
    nav_hall_of_shame: 'Sala Wstydu',
    nav_roastrank: 'RoastRank',
    nav_admin: 'Admin',
    nav_live: 'NA ŻYWO',
    nav_roasts_feed: 'Roasty',

    // RoastRank nav
    rr_home: 'Strona główna',
    rr_leaderboard: 'Ranking',
    rr_submit: 'Wyślij',
    rr_browse: 'Przeglądaj',
    rr_submit_roast: 'Wyślij Roast',

    // Home page
    home_live_label: 'Statystyki Społeczności Na Żywo',
    home_title: 'Przegląd Społeczności',
    home_desc: 'Rankingi w czasie rzeczywistym, osiągnięcia i aktywność we wszystkich społecznościach WhatsApp.',
    home_active_now: 'aktywnych teraz',
    home_community_pulse: 'Puls społeczności',
    home_activity_title: 'Aktywność Społeczności',
    home_activity_desc: 'Wiadomości i aktywni użytkownicy — ostatnie 14 dni',
    home_messages: 'Wiadomości',
    home_active_users: 'Aktywni Użytkownicy',
    home_cta_title: '🏆 Chcesz wspiąć się w rankingu?',
    home_cta_desc: 'Bądź aktywny, wysyłaj wiadomości, dołączaj do grup i utrzymuj serię. Sprawdzaj ranking codziennie.',

    // Leaderboard
    lb_community_rankings: 'Rankingi Społeczności',
    lb_title: 'Ranking',
    lb_desc: 'Najlepsi gracze w społeczności. Rankingi aktualizują się w czasie rzeczywistym.',
    lb_updated_live: 'Aktualizowane na żywo',
    lb_top3: '🏆 Top 3 Podium',
    lb_all_time: 'Ranking Wszech Czasów',
    lb_full_rankings: 'Pełny Ranking',
    lb_all_members: 'Wszyscy {n} członkowie społeczności w rankingu',

    // Hall of Fame
    hof_prestige: '✨ Galeria Prestiżu',
    hof_title: 'Sala Sławy',
    hof_desc: 'Najbardziej imponujące osiągnięcia w społeczności. Ci członkowie zasłużyli na swoje miejsce w historii.',
    hof_all_achievements: 'Wszystkie Osiągnięcia',
    hof_filter: 'Filtruj według kategorii',
    hof_achievements_count: '🏆 {n} Osiągnięć',

    // Hall of Shame
    hos_title: 'Sala Wstydu',

    // RoastRank home
    rr_roast_of_day: '🔥 ROAST DNIA',
    rr_trending: 'Na Topie',
    rr_top_roasters: 'Najlepsi Roasterzy',
    rr_country_rankings: 'Rankingi Krajów',
    rr_weekly_leaders: 'Liderzy Tygodnia',
    rr_add_entry: 'Dodaj Wpis',
    rr_share: 'Udostępnij',
    rr_pts_vote: 'pkt/głos',
    rr_hero_title: 'Najlepsze Roasty',
    rr_hero_subtitle: 'Głosuj na najlepsze roasty z całego świata',
    rr_browse_approved: 'Przeglądaj Zatwierdzone',

    // Submit page
    sub_title: 'Wyślij Swój Roast',
    sub_desc: 'Pokaż swój najlepszy roast i niech społeczność zdecyduje, czy jesteś legendą.',
    sub_how: 'Jak chcesz wysłać?',
    sub_type: 'Wpisz Tekst',
    sub_type_desc: 'Wpisz tekst roasta ręcznie',
    sub_screenshot: 'Prześlij Zrzut Ekranu',
    sub_screenshot_desc: 'Udostępnij zrzut ekranu z WhatsApp',
    sub_roast_label: 'Twój Roast',
    sub_roast_placeholder: 'Wpisz roast tutaj... Zrób to legendarnie. 🔥',
    sub_chars_needed: 'Potrzeba jeszcze {n} znaków',
    sub_good_length: '✓ Dobra długość',
    sub_upload_label: 'Zrzut Ekranu',
    sub_drop_here: 'Upuść zrzut ekranu tutaj lub kliknij, aby przeglądać',
    sub_file_types: 'PNG, JPG, WEBP do 10MB',
    sub_category: 'Kategoria',
    sub_country: 'Kraj',
    sub_select_country: 'Wybierz kraj...',
    sub_context: 'Kontekst (opcjonalnie)',
    sub_context_placeholder: 'Dodaj kontekst do roasta...',
    sub_agree: 'Zgadzam się, że ten roast jest oryginalny i nie narusza żadnych zasad.',
    sub_submit: 'Wyślij Roast 🔥',
    sub_submitting: 'Wysyłanie...',
    sub_success_title: 'Roast Wysłany! 🔥',
    sub_success_desc: 'Twój roast jest teraz dostępny dla społeczności do głosowania.',
    sub_success_review: 'Pojawi się w feedzie po szybkiej weryfikacji (zwykle poniżej 5 minut).',
    sub_back_home: 'Powrót do Strony Głównej',
    sub_submit_another: 'Wyślij Kolejny',

    // Browse roasts
    browse_title: 'Przeglądaj Roasty',
    browse_desc: 'Zatwierdzone roasty od społeczności. Głosuj na swoje ulubione!',
    browse_search: 'Szukaj roastów...',
    browse_all: 'Wszystkie',
    browse_no_results: 'Nie znaleziono roastów',
    browse_no_results_desc: 'Spróbuj innego filtra lub wróć później.',
    browse_loading: 'Ładowanie roastów...',
    browse_votes: 'głosów',
    browse_submitted: 'Wysłano',

    // Admin
    admin_title: 'Panel Admina',
    admin_sign_in: 'Zaloguj się, aby zarządzać zgłoszeniami roastów',
    admin_email: 'Email',
    admin_password: 'Hasło',
    admin_login: 'Zaloguj się',
    admin_logging_in: 'Logowanie...',
    admin_invalid_creds: 'Nieprawidłowe dane. Spróbuj ponownie.',
    admin_access_denied: 'Brak Dostępu',
    admin_no_permission: 'Nie masz uprawnień do tego panelu.',
    admin_sign_out: 'Wyloguj się',
    admin_all: 'Wszystkie',
    admin_pending: 'Oczekujące',
    admin_approved: 'Zatwierdzone',
    admin_rejected: 'Odrzucone',
    admin_search: 'Szukaj roastów, krajów, kategorii...',
    admin_refresh: 'Odśwież',
    admin_no_submissions: 'Nie znaleziono zgłoszeń',
    admin_approve: 'Zatwierdź',
    admin_reject: 'Odrzuć',
    admin_delete: 'Usuń',
    admin_notes: 'Notatki Admina (opcjonalnie)',
    admin_notes_placeholder: 'Dodaj notatkę o tym zgłoszeniu...',
    admin_delete_confirm: 'Trwale usunąć to zgłoszenie?',
    admin_screenshot: 'Zrzut ekranu dołączony',
    admin_context: 'Kontekst',
    admin_alltime_stats: 'Statystyki Wszech Czasów',
    admin_total_submissions: 'Łącznie Zgłoszeń',
    admin_total_approved: 'Łącznie Zatwierdzonych',
    admin_total_rejected: 'Łącznie Odrzuconych',
    admin_total_pending: 'Łącznie Oczekujących',
    admin_approval_rate: 'Wskaźnik Zatwierdzenia',
    admin_top_country: 'Kraj #1',
    admin_top_category: 'Kategoria #1',
    admin_back_roastrank: '← Powrót do RoastRank',
    admin_access: 'Dostęp Admina',
  },
  en: {
    // Nav
    nav_overview: 'Overview',
    nav_leaderboard: 'Leaderboard',
    nav_hall_of_fame: 'Hall of Fame',
    nav_hall_of_shame: 'Hall of Shame',
    nav_roastrank: 'RoastRank',
    nav_admin: 'Admin',
    nav_live: 'LIVE',
    nav_roasts_feed: 'Roasts Feed',

    // RoastRank nav
    rr_home: 'Home',
    rr_leaderboard: 'Leaderboard',
    rr_submit: 'Submit',
    rr_browse: 'Browse',
    rr_submit_roast: 'Submit Roast',

    // Home page
    home_live_label: 'Live Community Stats',
    home_title: 'Community Overview',
    home_desc: 'Real-time rankings, achievements, and activity across all WhatsApp communities.',
    home_active_now: 'active right now',
    home_community_pulse: 'Community pulse',
    home_activity_title: 'Community Activity',
    home_activity_desc: 'Messages and active users — last 14 days',
    home_messages: 'Messages',
    home_active_users: 'Active Users',
    home_cta_title: '🏆 Want to climb the ranks?',
    home_cta_desc: 'Stay active, send messages, join groups, and keep your streak alive. Check the leaderboard daily.',

    // Leaderboard
    lb_community_rankings: 'Community Rankings',
    lb_title: 'Leaderboard',
    lb_desc: 'The top performers in the community. Rankings update in real time.',
    lb_updated_live: 'Updated live',
    lb_top3: '🏆 Top 3 Podium',
    lb_all_time: 'All Time Rankings',
    lb_full_rankings: 'Full Rankings',
    lb_all_members: 'All {n} community members ranked',

    // Hall of Fame
    hof_prestige: '✨ Prestige Gallery',
    hof_title: 'Hall of Fame',
    hof_desc: 'The most impressive achievements in the community. These members have earned their place in history.',
    hof_all_achievements: 'All Achievements',
    hof_filter: 'Filter by category to explore',
    hof_achievements_count: '🏆 {n} Achievements',

    // Hall of Shame
    hos_title: 'Hall of Shame',

    // RoastRank home
    rr_roast_of_day: '🔥 ROAST OF THE DAY',
    rr_trending: 'Trending',
    rr_top_roasters: 'Top Roasters',
    rr_country_rankings: 'Country Rankings',
    rr_weekly_leaders: 'Weekly Leaders',
    rr_add_entry: 'Add Entry',
    rr_share: 'Share',
    rr_pts_vote: 'pts/vote',
    rr_hero_title: 'Top Roasts',
    rr_hero_subtitle: 'Vote for the best roasts from around the world',
    rr_browse_approved: 'Browse Approved',

    // Submit page
    sub_title: 'Submit Your Roast',
    sub_desc: 'Drop your best roast and let the community decide if you\'re legendary.',
    sub_how: 'How would you like to submit?',
    sub_type: 'Type It Out',
    sub_type_desc: 'Enter roast text manually',
    sub_screenshot: 'Upload Screenshot',
    sub_screenshot_desc: 'Share a WhatsApp screenshot',
    sub_roast_label: 'Your Roast',
    sub_roast_placeholder: 'Type the roast here... Make it legendary. 🔥',
    sub_chars_needed: '{n} more characters needed',
    sub_good_length: '✓ Good length',
    sub_upload_label: 'Screenshot',
    sub_drop_here: 'Drop screenshot here or click to browse',
    sub_file_types: 'PNG, JPG, WEBP up to 10MB',
    sub_category: 'Category',
    sub_country: 'Country',
    sub_select_country: 'Select country...',
    sub_context: 'Context (optional)',
    sub_context_placeholder: 'Add context to the roast...',
    sub_agree: 'I agree this roast is original and doesn\'t violate any rules.',
    sub_submit: 'Submit Roast 🔥',
    sub_submitting: 'Submitting...',
    sub_success_title: 'Roast Submitted! 🔥',
    sub_success_desc: 'Your roast is now live for the community to vote on.',
    sub_success_review: 'It\'ll appear in the feed once our quick review is complete (usually under 5 minutes).',
    sub_back_home: 'Back to Home',
    sub_submit_another: 'Submit Another',

    // Browse roasts
    browse_title: 'Browse Roasts',
    browse_desc: 'Approved roasts from the community. Vote for your favourites!',
    browse_search: 'Search roasts...',
    browse_all: 'All',
    browse_no_results: 'No roasts found',
    browse_no_results_desc: 'Try a different filter or check back later.',
    browse_loading: 'Loading roasts...',
    browse_votes: 'votes',
    browse_submitted: 'Submitted',

    // Admin
    admin_title: 'Admin Panel',
    admin_sign_in: 'Sign in to manage roast submissions',
    admin_email: 'Email',
    admin_password: 'Password',
    admin_login: 'Sign In',
    admin_logging_in: 'Signing in...',
    admin_invalid_creds: 'Invalid credentials. Please try again.',
    admin_access_denied: 'Access Denied',
    admin_no_permission: 'You don\'t have permission to access this panel.',
    admin_sign_out: 'Sign Out',
    admin_all: 'All',
    admin_pending: 'Pending',
    admin_approved: 'Approved',
    admin_rejected: 'Rejected',
    admin_search: 'Search roasts, countries, categories...',
    admin_refresh: 'Refresh',
    admin_no_submissions: 'No submissions found',
    admin_approve: 'Approve',
    admin_reject: 'Reject',
    admin_delete: 'Delete',
    admin_notes: 'Admin Notes (optional)',
    admin_notes_placeholder: 'Add a note about this submission...',
    admin_delete_confirm: 'Delete this submission permanently?',
    admin_screenshot: 'Screenshot attached',
    admin_context: 'Context',
    admin_alltime_stats: 'All-Time Stats',
    admin_total_submissions: 'Total Submissions',
    admin_total_approved: 'Total Approved',
    admin_total_rejected: 'Total Rejected',
    admin_total_pending: 'Total Pending',
    admin_approval_rate: 'Approval Rate',
    admin_top_country: 'Top Country',
    admin_top_category: 'Top Category',
    admin_back_roastrank: '← Back to RoastRank',
    admin_access: 'Admin Access',
  },
};

export type TranslationKey = keyof typeof translations.pl;

export function getTranslations(lang: Language) {
  return translations[lang] ?? translations.pl;
}
